module.exports = __webpack_public_path__ + "static/flasche-terra-naturell-a4a3e6d2e1eea37477b485fdc8c0ca0d.png";